<template lang="pug">
  .logout
</template>

<script>
import auth from '@/services/auth'

export default {
  mounted () {
    this.$store.dispatch('user/signOut')
    auth.signOut()
  }
}
</script>
